module.exports = __webpack_public_path__ + "static/media/business-cards-place-holder.563a3a8b.png";